import { Link } from '@material-ui/core';
import { Tooltip } from 'app/components/BasicTooltips/Tooltip';
import {
  RenderPageType,
  SidePanelContentProps,
} from 'app/Layout/FrontendLayout/slice/type';
import { ReactNode } from 'react';
import { DetectIsMobile } from 'utils/mobileDetect';
import { InvoiceDetails } from '..';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import useSidePanelState, {
  SidePanelOpenState,
} from 'app/hooks/useSidePanelOpen';

export interface InvoiceDetailsSidePanelProps extends SidePanelContentProps {
  id: number;
}

export const InvoiceDetailsSidePanel = (
  props: InvoiceDetailsSidePanelProps,
) => {
  return <InvoiceDetails id={props.id} useSidePanel={true} />;
};

export const InvoiceDetailsSidePanelLink = ({
  children,
  ...props
}: InvoiceDetailsSidePanelProps & { children: ReactNode }) => {
  const { t } = useTranslation();
  const { openPanel } = useSidePanelState();
  const isMobile = DetectIsMobile();

  const onClick = () => {
    openPanel({
      renderPageType: RenderPageType.InvoiceDetails,
      renderPageProps: props,
      expanded: !isMobile && !props.useSidePanel,
      useSidePanel: props.useSidePanel,
      isCover: props.useSidePanel,
    } as SidePanelOpenState);
  };
  return (
    <Tooltip title={t(translations.InvoiceDetails) as string} arrow>
      <Link onClick={onClick}>{children}</Link>
    </Tooltip>
  );
};
